import HotspotConstructor from '@3jss/Hotspot/HotspotConstructor';

/**
 * Get the intersected marker object.
 *
 * Traverses through intersects array to populate a list of interactable objects.
 *
 * Criterion for selecting interactive objects:
 * - Select sceneObject.object.owner (legacy) for hotspot not using HotspotConstructor. Object must have owner property and name === `marker`.
 * - Select sceneObject.object.userData.owner for hotspot using HotspotConstructor. Object needs to be constructed using HotspotConstructor mechanism.
 *
 * Once selected, the list is sorted by distance and the first object is returned.
 *
 * If no object is found, null is returned.
 *
 * @param {Array} intersects - The array of intersected objects as returned by raycaster.intersectObjects
 * @return {*|null}
 * @private
 */
const getIntersectedMarkerObject = (intersects) => {
	const objectsIntersected = intersects.reduce((acc, intersect) => {
		let intersected =
			intersect.object instanceof HotspotConstructor
				? intersect.object
				: false;

		if (intersect.object.name === 'marker') {
			intersected = intersect.object?.owner;

			if (!intersected) {
				console.warn('Legacy Hotspot with name `marker` missing owner');
			}
		}

		if (intersect?.object?.belongsToAvatar) {
			acc.push({
				object: intersect.object?.avatarInstance,
				distance: intersect.distance,
			});
		}

		if (!intersected) {
			intersect.object.traverseAncestors((parent) => {
				if (parent instanceof HotspotConstructor) {
					intersected = parent;
				}
			});
		}

		if (intersected) {
			// Only include visible objects
			if (intersected.visible) {
				acc.push({
					object: intersected,
					distance: intersect.distance,
				});
			}
		} else if (intersect.object.forceCollisionDetection) {
			intersected = intersect.object;
			acc.push({
				object: intersected,
				distance: intersect.distance,
			});
		}
		return acc;
	}, []);

	if (objectsIntersected.length > 0) {
		objectsIntersected.sort((a, b) => a.distance - b.distance);
		return objectsIntersected[0];
	}

	return null;
};

export { getIntersectedMarkerObject };
